<template>
  <div class="app-header">
    <div class="header-content">
      <div class="header-top">
        <div class="header_left">
          <el-image style="width: 350px;" :src="require('@@/assets/login1.png')"></el-image>
        </div>
        <div class="header_right">
          <div v-if="islogin === false">
            <el-button type="" size="medium"
              style="border: 1px solid #13319f;padding:10px 30px;background-color: #13319f;color: #ffffff"
              @click="logondialog('/login')">登录</el-button>
            <el-button type="" size="medium" style="border: 1px solid #13319f;padding:10px 30px;color: #13319f"
              @click="showdialog('/register')">注册</el-button>
          </div>
          <div v-else>
            <div>
              {{ nickName }}
              <el-button type="text" size="medium" style="padding:0px 5px;color: #1890FF" @click="exit()">退出</el-button>
            </div>
            <el-button type="text" size="medium" style="color: #1890FF;margin-left: 10px"
              @click="railsc()">进入控制台</el-button>
          </div>
        </div>
      </div>
      <div class="header-menu">
        <div class="header-elMenu">
          <el-menu mode="horizontal" :default-active="current" active-text-color="#fff" background-color="#13319f"
            text-color="#fff" ref="menu" @select="handleSelect">
            <template v-for="item in menuItems">
              <el-menu-item v-if="!item.children || !item.children.length" :key="item.key" :index="item.location">
                <a :href="item.location" @click.prevent>{{ item.label }}</a>
              </el-menu-item>
              <el-submenu v-else :key="item.key" :index="item.location" popper-class="navTwo"
                :popper-append-to-body=false>
                <template slot="title"> <a style="color: #fff" :href="item.location" @click.prevent>{{ item.label
                    }}</a></template>
                <el-menu-item v-for="child in item.children" :key="child.key" :index="child.location">
                  <a style="color: #fff" :href="child.location" @click.prevent>{{ child.label }}</a>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </div>
    </div>
    <el-dialog title="请选择注册方式" :visible.sync="dialogVisible" width="500px">
      <div style="text-align: center">
        <el-button @click="$router.push({ path: '/vendorRegister' })">供应商注册</el-button>
        <!--        <el-button @click="selectLogo(3)">采购人注册</el-button>-->
      </div>
    </el-dialog>
    <!-- 遮罩层 -->
    <div class="login-mask" v-if="logoDialog" @click="closeLoginDialog"></div>
    <!-- 登录弹窗 -->
    <div class="login-dialog" v-if="logoDialog" @keydown.esc="closeLoginDialog">
      <div class="dialog-header">
        <span class="title">请选择登录方式</span>
        <div class="close-icon" @click="closeLoginDialog">
          <img src="@/assets/guanbi.png" alt="关闭" />
        </div>
      </div>
      <div class="login-options">
        <div class="login-option" @click="selectLogo(2)">
          <span>供应商登录</span>
        </div>
        <div class="login-option" @click="selectLogo(3)">
          <span>采购人登录</span>
        </div>
        <div class="login-option" @click="selectLogo(5)">
          <span>平台方登录</span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showAgreement" width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div ref="agreementContent" class="agreement-content" @scroll="checkScroll"
        style="overflow-y: auto;height: 40vh;">
        <!-- 这里放具体的保密协议内容 -->
        <!-- 放一个png图片 -->
        <img src="@/assets/baomi.png" alt="agreement" style="width: 100%;" />
      </div>

      <div slot="footer" style="text-align: center;">
        <div style="margin-top: 10px;margin-bottom: 10px;color: red;font-size: small;text-align: center;">
          请将滚动条滚动到底部，确认已阅读并同意保密协议。
        </div>
        <el-button type="primary" @click="agreeAgreement" :disabled="!isScrolledToBottom">
          同意协议
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { removeToken } from "@/utils/auth";
import { getLoginStatus, noticeRecordApi, searchNoticeApi } from "@/api/api";
export default {
  data() {
    return {
      dialogVisible: false,
      hasReadInSession: false,
      topath: "",
      current: "/home",
      islogin: false,//是否已登陆
      nickName: '',
      showAgreement: false,
      isScrolledToBottom: false,
      show1: false,
      menuItems: [
        {
          label: "首页",
          location: "/home",
          key: '1'
        },
        {
          label: "旭诚云采",
          location: "/xcyc",
          key: '2'
        },
        {
          label: "旭诚云市",
          location: "/xcys",
          key: '3'
        },
        {
          label: "合同签署",
          //跳转到https://www.xcsw.net/contract/#/contract/PartyB
          location: "/contractSign",
          key: '5'
        },
        {
          label: "下载中心",
          location: "/download",
          key: '6'
        },
        {
          label: "帮助中心",
          location: "/help",
          key: '7'
        },

        {
          label: "联系我们",
          location: "/ourself",
          key: '8'
        },
      ],
      logoDialog: false,
    };
  },
  created() {
    if (Cookies.get('Admin-Token')) {
      this.islogin = true;
      this.nickName = Cookies.get('nickName')
    }
    let menu = sessionStorage.getItem("menu");
    this.current = menu ? (menu == "/" ? "/home" : menu) : "/home";
    // 从 sessionStorage 读取是否已滚动到底部的状态
    this.hasReadInSession = sessionStorage.getItem('hasReadAgreement') === '1';
    if (this.hasReadInSession) {
      this.isScrolledToBottom = true;
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
    const dialogBody = this.$el.closest('.el-dialog__body');
    if (dialogBody) {
      const dialogHeight = dialogBody.clientHeight;
      this.$refs.agreementContent.style.maxHeight = `${dialogHeight - 100}px`;
    }
    this.$bus.$on("changeMainNav", (data) => {
      this.current = data
    });
    // 移除原有的 noticeRecordApi() 调用
  },
  watch: {
    logoDialog(newVal) {
      if (newVal) {
        // 打开弹窗时禁止滚动
        document.body.style.overflow = 'hidden';
        // 打开弹窗时绑定事件
        window.addEventListener('keydown', this.handleKeydown);
      } else {
        // 关闭弹窗时恢复滚动
        document.body.style.overflow = 'auto';
        // 关闭弹窗时解绑事件
        window.removeEventListener('keydown', this.handleKeydown);
      }
    },
    '$route': {
      immediate: true,
      handler(n) {
        if (n.path.indexOf('about') != -1) {
          this.$nextTick(() => this.current = '/about')
        } else {
          this.$nextTick(() => this.current = n.path)
        }
      }
    }
  },
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    closeLoginDialog() {
      this.logoDialog = false;
      // 关闭弹窗时恢复滚动
      document.body.style.overflow = 'auto';
    },
    handleKeydown(e) {
      if (e.keyCode === 27) { // ESC键的keyCode是27
        this.logoDialog = false;
      }
    },
    // 修改后的 searchNoticeApi 方法
    searchNoticeApi() {
      searchNoticeApi().then(res => {
        if (res.data.isRead == "true") {
          console.log('已阅读过')
          location.href = `${process.env.VUE_APP_LOGINURL}`;
        } else {
          console.log('未阅读过')
          this.showAgreement = true // 正确控制保密协议弹窗
          sessionStorage.removeItem('hasReadAgreement') // 新增
          this.hasReadInSession = false // 新增
          this.$nextTick(() => {
            const img = this.$refs.agreementContent.querySelector('img')
            img.onload = () => {
              this.checkScroll() // 图片加载完成后重新计算
            }
          })
        }
      })
    },
    noticeRecordApi() {
      return noticeRecordApi().then(res => {
        location.href = `${process.env.VUE_APP_LOGINURL}`;
      })
    },
    checkScroll() {
      const el = this.$refs.agreementContent
      const threshold = 5 // 允许5像素的误差
      this.isScrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold

      if (this.isScrolledToBottom && !this.hasReadInSession) {
        sessionStorage.setItem('hasReadAgreement', '1')
        this.hasReadInSession = true
      }
    },
    async agreeAgreement() {
      this.$message.success('协议提交成功')
      try {
        await this.noticeRecordApi() // 等待协议记录接口完成
      } catch (error) {
        console.error('提交协议失败:', error)
        this.$message.error('协议提交失败，请重试')
      }
    },
    railsc() {
      if (!Cookies.get('Admin-Token')) {
        return this.$message.warning('请先登录')
      }

      this.searchNoticeApi() // 先检查协议状态
      this.$nextTick(() => {
        this.hasReadInSession = sessionStorage.getItem('hasReadAgreement') === '1'
        this.isScrolledToBottom = this.hasReadInSession
      })
    },
    // 顶部导航跳转
    handleSelect(path) {
      if (path === '/xcyc') {
        if (Cookies.get('Admin-Token')) {
          location.href = `${process.env.VUE_APP_OLDHOME}`
        } else {
          return this.$message('还未登录');
        }
      }
      if (path === '/xcys') {
        window.open(`https://xcsw-pc.xcsw.net:7443/`)

        /*if (Cookies.get('Admin-Token')) {
          getLoginStatus().then(res => {
            let data = res.data
            if (data.identity === "gys") {
              // 供应商
              if (data.state) {
                window.open(`/redirect?r=https://xcsw-multishop.xcsw.net:7443/`)
              } else {
                this.$message.warning('未通过主体认证或入库审核还未通过')
              }
            } else if (data.identity === "ptf") {
              // 平台方
              window.open(`/redirect?r=https://xcsw-platform.xcsw.net:7443/`)
            } else if (data.identity === "cgr") {
              // 采购人
              if (data.state) {
                window.open(`/redirect?r=https://xcsw-pc.xcsw.net:7443/`)
              } else {
                this.$message.warning('未通过主体认证或平台审核还未通过')
              }
            }
          }).catch()
        } else {
          return this.$message('还未登录');
        }*/
      }
      if (path === '/zhwl') {
        return window.open(`https://www.xcsw.net/ui/#/auxiliaryMeans/listPrice`)
      }
      if (path === '/xcyp') {
        return window.open(`https://xczl.xyc.llschain.com`)
      }
      if (path === '/zqyl') {
        return window.open(`https://www.xcsw.net/contract/#/contract/PartyB`)
      }
      if (path === '/contractSign') {
        if (Cookies.get('Admin-Token')) {
          location.href = `${process.env.VUE_APP_CONTRACT_LOGINURL}`;
        } else {
          this.logoDialog = true;
        }
        return;
      }
      this.toPage(path);
    },
    logondialog(path) {
      this.logoDialog = true
      this.topath = path;
    },
    showdialog(path) {
      this.dialogVisible = true;
      this.topath = path;
    },
    selectLogo(val) {
      this.toPage('/login', val);
    },
    // 页面跳转
    toPage(path, val) {
      if (path == '/guarantee') window.open('http://www.gzzczb.com/guarantee/')
      // if (path == '/bidEvaluationOffice') window.open('http://www.gzzczb.com/bidEvaluationOffice/')
      this.$router.push({ path: path, query: { type: val } });
    },
    exit() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$store.dispatch('LogOut').then(() => {
        removeToken()
        location.href = '/home';
        // })
      }).catch(() => { });
    },
  },
};
</script>
<style scoped lang="less">
// 登录遮罩层样式
.login-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // 半透明黑色背景
  z-index: 1999; // 确保在弹窗下方
  transition: opacity 0.3s ease; // 添加淡入淡出效果
}

// 登录弹窗样式
.login-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 720px;
  max-width: 90%;
  background-color: white; // 弹窗背景为白色
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 2000; // 确保在遮罩层上方
  transition: all 0.3s ease; // 添加过渡效果

  // 弹窗标题栏
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 84px;
    padding: 0 30px;
    background: url(@/assets/longing_title.png) 100%/cover no-repeat;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 22px;
      font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
    }

    .close-icon {
      cursor: pointer;

      img {
        width: 19px;
        height: 19px;
      }
    }
  }

  // 登录选项
  .login-options {
    padding: 24px 0;

    .login-option {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      width: 400px;
      max-width: 80%;
      margin: 24px auto;
      border: 1px solid rgba(220, 220, 220, 1);
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      transition: all 0.3s ease;

      span {
        color: rgba(51, 51, 51, 1);
        font-size: 20px;
        font-family: Helvetica, 'Microsoft YaHei', Arial, sans-serif;
      }

      &:hover {
        background-color: #409EFF;
        border-color: #409EFF;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);

        span {
          color: white;
        }
      }
    }
  }
}

// 防止遮罩层和弹窗出现滚动条
body.modal-open {
  overflow: hidden;
}

.agreement-content {
  line-height: 1.6;
  padding: 20px;
  text-align: justify;
  position: relative;
  /* 新增 */

  h2 {
    text-align: center;
    font-size: 2rem;
    color: #2c3e50;
  }

  p {
    margin-bottom: 15px;
    text-indent: 2em;
  }

  texta {
    text-indent: 2em;
  }
}

.app-header {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 150px;

}

.header-content {
  width: 100%;
  height: 100%;
}

.header-top {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
}

.header_left {
  display: flex;
  align-items: center;
}

.header-menu {
  height: 50px;
  background-color: #13319f;
}

.header-elMenu {
  width: 1400px;
  height: 100%;
  margin: 0 auto;
}

/deep/ .el-menu {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/deep/ .el-menu-item {
  height: 100%;
  width: calc(100% / 8);
  text-align: center;
  line-height: 48px;
  font-size: 18px;
  border-bottom: none !important;
}

/deep/ .el-submenu {
  height: 100%;
  width: calc(100% / 8);
  text-align: center;
  font-size: 18px;
  border-bottom: none !important;
}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 100%;
  line-height: 48px;
  font-size: 18px;
}

/deep/ .el-menu.el-menu--horizontal {
  border-bottom: #13319f;
}

&>div {
  height: inherit;
  align-items: center;
}

/deep/ .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: #13319f;
  background-color: #13319f !important;

}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  background-color: #0b247d !important;
  color: #fff !important;
}

/deep/ .el-menu-item:focus,
.el-menu-item:hover {
  background-color: #0b247d !important;
  color: #fff !important;
}

/deep/ .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
  display: none;

}

/deep/ .el-submenu>.el-submenu__title .el-submenu__icon-arrow {
  display: none;
}

/deep/ .el-menu--horizontal.navTwo {
  top: 43px !important;
}

/deep/ ul.el-menu.el-menu--popup.el-menu--popup-bottom-start {
  display: flex;
  flex-direction: column;
  min-width: 176.47px !important;
}

/deep/ .el-submenu li.el-menu-item {
  min-width: 176.47px !important;
  line-height: 48px !important;
  height: 48px !important;
}

/deep/ .el-submenu__title {
  border-bottom: none !important;
}
</style>